var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.375V2.4375C6.75 1.71234 7.3793 1.125 8.15625 1.125H14.3438C15.1207 1.125 15.75 1.71234 15.75 2.4375V11.0625C15.75 11.7877 15.1207 12.375 14.3438 12.375H13.5M9.84375 16.875H3.65625C2.8793 16.875 2.25 16.2877 2.25 15.5625V6.9375C2.25 6.21234 2.8793 5.625 3.65625 5.625H9.84375C10.6207 5.625 11.25 6.21234 11.25 6.9375V15.5625C11.25 16.2877 10.6207 16.875 9.84375 16.875Z",
    stroke: "#AAACAB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f02a4c9e3315d2177e7de9ccaa018995.svg";
export { ForwardRef as ReactComponent };